import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpCreditMemoService from '../../../Services/CreditMemo/TpCreditMemoService';
import TpCreditMemoItem from '../../../Domain/CreditMemo/TpCreditMemoItem';
import TpCreditMemoStatusEnum from '../../../Enums/CreditMemoStatusEnum';
import TpCreditMemoReasonEnum from '../../../Enums/CreditMemoReasonEnum';

export default class EditTpCreditMemoWindowDescription {
  static titleForCreate = 'Create New Credit Memo';
  static titleForEdit = 'Edit Credit Memo';
  static itemType = TpCreditMemoItem;
  static serviceFunction = TpCreditMemoService.Upsert;

  static navigateToOnCreation = '/tpcreditmemo/search?SelectedOfficeIds=&TpClientInvoiceId=';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CaspianClientId',
          label: 'Client *',
          className: 'col-6',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !!item.TpCreditMemoId || item.FromClientInvoice === true,
        },
        {
          fieldName: 'TpClientInvoiceId',
          label: 'Invoice *',
          className: 'col-6',
          type: InputTypesEnum.TpCreditMemoTpClientInvoiceSelect,
          idFilter: 'CaspianClientId',
          validityChecker: ValidityHelper.forRequiredSelectField,
          disabled: (item) => !item.CaspianClientId,
          hide: (item) => !!item.TpCreditMemoId || item.FromClientInvoice === true,
        },
        {
          fieldName: 'Reason',
          label: 'Reason *',
          className: 'col-6',
          type: InputTypesEnum.TpCreditMemoReasonLookupItemSelect,
          validityChecker: EditTpCreditMemoWindowDescription.forTpCreditMemoReasonChange,
          hide: (item) => item.Status && item.Status != TpCreditMemoStatusEnum.Created,
        },
        {
          fieldName: 'InternalReferenceNumber',
          label: 'Internal Reference #',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.Status && item.Status != TpCreditMemoStatusEnum.Created,
        },
        {
          fieldName: 'Description',
          label: 'Description *',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.Status && item.Status != TpCreditMemoStatusEnum.Created,
        },
        {
          fieldName: 'InternalInformation',
          label: 'Internal Information *',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.Status && item.Status != TpCreditMemoStatusEnum.Created,
        },
        {
          fieldName: 'AssignedTo',
          label: 'Assigned To *',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          roleKey: 'tpcreditmemo_editassignee',
          hide: (item) => !item.TpCreditMemoId,
        },
      ],
    },
  ];

  static forTpCreditMemoReasonChange(e, editedItem) {
    if (!editedItem.Reason) return "This field can't be empty.";

    if (
      editedItem.OldReason != editedItem.Reason &&
      (editedItem.OldReason === TpCreditMemoReasonEnum.LateFeeCredit ||
        editedItem.Reason === TpCreditMemoReasonEnum.LateFeeCredit) &&
      editedItem.NumberOfItemsCredited > 0
    ) {
      return 'Unable to change Credit Memo reason to or from Late Fee Credit. Please unapply credit from the invoice line items before proceeding.';
    }

    if (
      editedItem.OldReason != editedItem.Reason &&
      (editedItem.OldReason === TpCreditMemoReasonEnum.TaxCredit ||
        editedItem.Reason === TpCreditMemoReasonEnum.TaxCredit) &&
      editedItem.NumberOfItemsCredited > 0
    ) {
      return 'Unable to change Credit Memo reason to or from Tax Credit. Please unapply credit from the invoice line items before proceeding.';
    }

    return '';
  }
}
